// GovWellRequestHeaders is duplicated on the BE
export enum GovWellRequestHeaders {
  ActiveOrgId = 'X-Govwell-Active-Org-Id',
  Platform = 'X-Govwell-Platform',
  TimeZone = 'X-Govwell-Time-Zone',
  FlagOverrides = 'X-Govwell-Flag-Overrides',
}
